module.exports = __webpack_public_path__ + "img/master-visual.7d2e7620.png";